import { render, staticRenderFns } from "./StripeSetup.vue?vue&type=template&id=0195588e&scoped=true"
import script from "./StripeSetup.vue?vue&type=script&lang=js"
export * from "./StripeSetup.vue?vue&type=script&lang=js"
import style0 from "./StripeSetup.vue?vue&type=style&index=0&id=0195588e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0195588e",
  null
  
)

export default component.exports